import React from 'react';
import classNames from 'classnames';
import { QuantitiesOptions } from 'utils/components/QuantitiesOptions/QuanitiesOptions';

export interface QuantitiesOptionsLinksProps {
    value: QuantitiesOptions;
    onChange: (nextValue: QuantitiesOptions) => void;
}

export default function QuantitiesOptionsLinks(
    props: QuantitiesOptionsLinksProps
) {
    const { value, onChange } = props;

    const onTradedClicked = () => onChange('traded');
    const onLeavesClicked = () => onChange('leaves');
    const onOrderedClicked = () => onChange('ordered');

    return (
        <div className="QuantitiesOptionsLinks toolbar-links quantities">
            <div
                className={classNames(
                    'text-link',
                    value === 'ordered' && 'active'
                )}
                onClick={onOrderedClicked}
            >
                Ordered
            </div>{' '}
            <div
                className={classNames(
                    'text-link',
                    value === 'traded' && 'active'
                )}
                onClick={onTradedClicked}
            >
                Traded
            </div>
            <div
                className={classNames(
                    'text-link',
                    value === 'leaves' && 'active'
                )}
                onClick={onLeavesClicked}
            >
                Leaves
            </div>
        </div>
    );
}
